<script setup lang="ts">

import {ShowcaseItem} from "@/core/interfaces/showcase";
import {computed, ref, watch} from "vue";
import {Slider} from "@/core/components/ui/slider";
import {currencyze} from "@/core/filters/Currencyze";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";

const props = defineProps<{
    item: ShowcaseItem;
}>();

const emits = defineEmits<{
    (event: 'marginChange', value: number): void;
}>();

const rate = ref(props.item.meta.default_grow_rate ?? 100);

const handleRateChange = (value?: number[]) => {
    if (!value || value.length === 0) {
        return;
    }

    rate.value = value[0];
};

const computedValue = computed(() => {
    return (props.item.value as number) * (rate.value / 100);
});

watch(() => computedValue.value, (newValue) => {
    emits("marginChange", newValue);
}, {immediate: true});
</script>

<template>
  <div>
    <div class="flex items-center gap-2 pb-4">
      <p>0€</p>
      <Slider
        :model-value="[rate]" :default-value="[rate]" :max="100" :step="1"
        @update:model-value="handleRateChange"
      >
        <template #thumb>
          <div class="relative top-4 -translate-x-1/2 text-xs text-primary">
            {{ currencyze(computedValue, 0) }}
          </div>
        </template>
      </Slider>
      <p class="font-bold text-primary">
        {{ currencyze(item.value as number, 0) }}
      </p>
      <InformationTooltip v-if="item.tooltip" class="w-4 h-4 text-primary">
        <div class="max-w-2xl">
          <div>
            <p>
              En moyenne, les pharmacies Apodis réalisent <span class="font-bold">{{ item.meta.default_grow_rate ?? 100 }}%</span> de leur potentiel
              la première année d’utilisation
            </p>
            <p>
              Votre revenu potentiel 1ère année est estimé à <span class="font-bold">{{ currencyze(computedValue, 0) }}</span>
            </p>
            <p>
              Votre potentiel MAX est de <span class="font-bold">{{ currencyze(item.value as number, 0) }}</span>
            </p>
          </div>
          <br>
          <div>
            <p>{{ item.tooltip }}</p>
          </div>
        </div>
      </InformationTooltip>
    </div>
  </div>
</template>

<style scoped>

</style>
